import React from 'react';
import ItemSelector from '../../shared/ItemSelector';
/**
 * It allows to configure what should be displayed
 */
export const DisplayFilter = ({ lineups, displayTypes }) => (
  <div className="form-row">
    <div className="form-column">
      <div className="form-group">
        <label>Select a Lineup to Highlight</label>
        <ItemSelector {...lineups} />
      </div>
    </div>
  </div>
);
